import { body, request } from "services/request";

const resource = "api/crStart";

export const getServices = () => request(`${resource}/getServices`, { method: "GET" });

export const subscribe = (params: { tariffServiceId: number; periodId: number }) =>
    request(`${resource}/subscribe`, body(params));
